<template>
    <!-- Top Bar -->
    <nav class="navbar navbar-default no-margin app-sidebar-nav">
        <div v-if="currentEnvironment" class="notification-block notification-block-top">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-primary alert-dismissible">
                <div class="scroll-left">
                    <p>This is Test Environment !</p>
                </div>
            </div>
        </div>
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header fixed-brand">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" id="menu-toggle">
                <span class="glyphicon glyphicon-th-large" aria-hidden="true"></span>
            </button>
            <a class="navbar-brand" href="javascript:void(0)"><img src="/static/images/vvglogonew.png" alt="Velocity Vehicle Group"></a>
        </div>
        <!-- navbar-header-->
        <div class="collapse-btn navbar-collapse" id="bs-example-navbar-collapse-1">
            <ul class="nav navbar-nav">
                <li class="active">
                    <button class="navbar-toggle collapse-btn in" data-toggle="collapse" id="menu-toggle-2"> 
                        <img src="/static/images/menubar.png" alt="Menu" class="menubar">
                    </button>
                </li>
            </ul>
        </div>
        <div class="user-info">
            <div class="user-info-container">
                <div class="dropdown">
                    <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                        <div class="dropdown-user">
                            <!--<div class="image"><img :src="image" alt="User" width="48" height="48"></div>-->
                            <div class="username-letter">{{loggedin_user_img}}</div>
                            <div class="dropdown-user-right">
                                <div class="username">{{formatString(firstName)}} {{formatString(lastName)}}</div>
                                <br/>
                                <div class="usermailid">{{userName}}</div>
                            </div>
                        </div>
                    </button>
                    <div class="dropdown-menu">
                        <router-link class="dropdown-item" v-bind:to="{name: 'viewProfile',params:{id:loggedinUserId}}">Profile</router-link>
                        <router-link class="dropdown-item" v-bind:to="{name: 'ChangePassword'}">Change Password</router-link>
                        <a class="dropdown-item" href="javascript:void(0)" v-on:click="logout"><!-- Sign Out -->Logout</a>
                    </div>
                </div>
            </div>
        </div>
        <!--userinfo-->
        <!-- bs-example-navbar-collapse-1 -->
    </nav>
    <!-- <nav class="navbar">
        <span class="openbtn opensidebar" v-on:click="openNav()">&#9776;</span>
        <span class="openbtn closesidebar" v-on:click="closeNav()">&#9776;</span>
        <div class="container-fluid">
            <div class="navbar-header">
                <router-link class="navbar-brand" v-bind:to="{ path:'/listcustomer'}" href="#"><img src="/static/images/vvg-crm-logp-dash.png" alt="Velocity Truck Center"></router-link>
            </div>
            <div class="btn-group user-helper-dropdown pull-right top_menu">
                <div class="user-info" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    <div class="image">
                        <img src="/static/images/user.png" width="48" height="48" alt="User" />
                    </div>
                    <div class="info-container">
                        <div class="name">{{ firstName }} {{ lastName }}</div>
                        <div class="email">{{ userName }}</div>

                    </div>
                </div>
                <ul class="dropdown-menu pull-right">
                    <li><router-link v-bind:to="{name: 'viewProfile',params:{id:loggedinUserId}}"><i class="material-icons">person</i>Profile</router-link></li>
                    <li role="separator" class="divider"></li>
                    <li><router-link v-bind:to="{name: 'ChangePassword'}"><i class="material-icons">vpn_key</i>Change Password</router-link></li>
                    <li role="separator" class="divider"></li>
                    <li><a href="javascript:void(0)" v-on:click="logout"><i class="material-icons">input</i>Sign Out</a></li>
                </ul>
            </div>
        </div>
    </nav> -->
</template>
<script>
    import EventBus from '../event-bus';
    import SessioMixin from '../../mixins/sessionmixin';
    var contex;
    export default {
        mixins: [SessioMixin],
        data: () => ({
                isShowLoggedinfields: true,
                isLoggedIn: false,
                loggedin_user_img: '',
                firstName: "",
                lastName: "",
                userName: "",
                loggedinUserId: ""
            }),
        components: {
        },
        beforeMount: function () {
            contex = this;
            var app = this;
            var check = window.localStorage.getItem('api_token');
            //console.log(check);

            if (!check) {
                // app.$router.push({path: '/login'});
            } else {
                // get loggedin obj
                var userObj = localStorage.getItem("user_obj");
                if (userObj != null) {

                    var userJson = JSON.parse(userObj);
                    app.loggedinUserId = userJson.id;

                    app.firstName = userJson.first_name;
                    app.lastName = userJson.last_name;
                    app.userName = userJson.username;
                    // if (userJson.roles.length > 0) {
                    //     //self.userRole = userJson.roles[0].name;
                    // }
                }
            }
        },
        mounted: function () {
            if (localStorage.getItem("menu_small") == '1') {
                this.closeNav();
            } else {
                this.openNav();
            }
        },
        methods: {
            logout: function () {
                /* localStorage.clear();
                self.$router.push("/"); */
                let current_build = window.localStorage.getItem("build_version");
                localStorage.clear();
                localStorage.setItem("build_version", current_build);
                window.location.href = process.env.SSO_ROOT_URL + "/logout?redirect_url=" + process.env.FRONT_ROOT_URL + '&slug=' + process.env.PROJECT_SLUG;
                // window.location.href = process.env.SSO_ROOT_URL + "/home?logout=true&redirect=" + process.env.FRONT_ROOT_URL + '?slug=' + process.env.PROJECT_SLUG;
            },
            closeNav: function () {
                //alert('close');
                window.localStorage.setItem("menu_small", '1');
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            openNav: function () {
                //alert('open');
                window.localStorage.setItem("menu_small", '0');
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            },
            formatString(data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp.toUpperCase();
            },
        }
    }
    EventBus.$on('logged-in', function (isLogin, fname, lname, email) {
        if (typeof (contex) != "undefined") {
            contex.isShowLoggedinfields = isLogin;
            // contex.firstName = fname.trim();
            // contex.lastName = lname.trim();
            // contex.userName = email;
            contex.loggedin_user_img = (contex.firstName.charAt(0) + contex.lastName.charAt(0)).toUpperCase();
            if (contex.loggedin_user_img == "") {
                contex.loggedin_user_img = (contex.userName.charAt(0) + contex.userName.charAt(1)).toUpperCase();
            }
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/partials/FrontHeader.vue